import { fieldFacet, listConfig, weekFacet, type Facet, type GameRow } from '@region13/shared-types'

/** The coach portal's game lists: one team's games, about ten a season. */
export const COACH_GAMES_LIST = listConfig([weekFacet([]), fieldFacet], { sorts: [], hidePastDefault: true })

/** Week and Field facets over one team's rows. The week facet is built from
 *  every loaded row so it survives a toggle back to "show past". */
export function coachGameFacets<Row extends GameRow>(rows: readonly Row[]): Facet<Row>[] {
  return [weekFacet<Row>(rows), fieldFacet]
}
